import { MOBILE_V1 } from './utils/endpoints';
/* eslint-disable id-length */

export default (_ref, updateContext, getContext) => {
  var shared = _ref.shared;
  var apiClient = shared.apiClient,
    getAbsoluteUrl = shared.getAbsoluteUrl,
    addListener = shared.addListener;
  /* eslint-disable no-unused-vars */
  var postWithToken = apiClient.postWithToken;
  var endpoint = action => "".concat(getAbsoluteUrl(MOBILE_V1), "/preferences/").concat(action);
  var preferencesRequested = false;
  var _ref2 = getContext() || {},
    _ref2$user = _ref2.user,
    currentUser = _ref2$user === void 0 ? {
      type: 'anonymous'
    } : _ref2$user;
  var FETCH = endpoint('fetch');
  var MERGE = endpoint('merge');
  var fetchUserPreferences = async () => {
    updateContext({
      isUserPreferencesLoaded: false
    });
    var preferences = {};
    var _getContext = getContext(),
      user = _getContext.user;
    if (user.type === 'authenticated') {
      try {
        preferences = (await postWithToken(FETCH)).preferences;
      } catch (error) {
        console.warn('Caught error fetching preferences:', error); // eslint-disable-line no-console
      }
    }
    updateContext({
      isUserPreferencesLoaded: true,
      userPreferences: preferences
    });
    return preferences;
  };
  var mergeUserPreferences = preferences => postWithToken(MERGE, {
    preferences
  }).then(() => fetchUserPreferences());
  addListener(() => {
    var _ref3 = getContext() || {},
      requestedValues = _ref3.requestedValues,
      user = _ref3.user;
    if (!preferencesRequested && requestedValues.has('userPreferences')) {
      preferencesRequested = true;
      fetchUserPreferences();
    } else if (currentUser !== user && preferencesRequested) {
      currentUser = user;
      fetchUserPreferences();
    }
  });
  var preferenceApi = {
    isUserPreferencesLoaded: false,
    userPreferences: {},
    mergeUserPreferences
  };
  return preferenceApi;
};